import React from 'react';
import styled from 'styled-components';
import Config from '@configs/Environments';

type ErrorProps = {
    message: null | string,
};

const Error = (props: ErrorProps) => {
    const { message } = props;

    return (
        <ErrorWithStyled>
            { Config.ERROR_MODE ?
                <DevelopmentErrorWithStyled>
                    <DevelopmentErrorCodeWithStyled>
                        { message }
                    </DevelopmentErrorCodeWithStyled>
                </DevelopmentErrorWithStyled>
            :
                <ProductionErrorWithStyled>
                    <ProductionErrorTextWithStyled className="text-red">
                        エラーが発生しました。
                    </ProductionErrorTextWithStyled> 
                </ProductionErrorWithStyled>
            }
        </ErrorWithStyled>
    )
}

const ErrorWithStyled = styled.div`
`
const DevelopmentErrorWithStyled = styled.div`
`
const DevelopmentErrorCodeWithStyled = styled.code`
`
const ProductionErrorWithStyled = styled.div`
`
const ProductionErrorTextWithStyled = styled.div`
`

export default Error;